export const placeholderProductsInfo = {
    placeholder_1: {
        identifier: "placeholder_1",
        image: {
            id: 1,
            warhole_id: 1,
            thumbnails: {
                thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
                full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-1.jpg",
            },
        },
        min_price: 3400,
        max_price: 3400,
        name: "Cambiá tu equipo con ahora 12",
        url: "",
        language: "es-MX",
    },
    placeholder_2: {
        identifier: "placeholder_2",
        image: {
            id: 1,
            warhole_id: 1,
            thumbnails: {
                thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
                full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-2.jpg",
            },
        },
        min_price: 3400,
        max_price: 3400,
        name: "Accesorios",
        url: "",
        language: "es-MX",
    },
    placeholder_3: {
        identifier: "placeholder_3",
        image: {
            id: 1,
            warhole_id: 1,
            thumbnails: {
                thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
                full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-3.jpg",
            },
        },
        min_price: 3400,
        max_price: 3400,
        name: "Cambiá tu equipo",
        url: "",
        language: "es-MX",
    },
    placeholder_4: {
        identifier: "placeholder_4",
        image: {
            id: 1,
            warhole_id: 1,
            thumbnails: {
                thumbnail: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                small: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                medium: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                large: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
                full: "https://newrt.s3.amazonaws.com/emptystates/productsCarousel/productsCarousel-4.jpg",
            },
        },
        min_price: 3400,
        max_price: 3400,
        name: "Música",
        url: "",
        language: "es-MX",
    },
};
//# sourceMappingURL=placeholderProductsInfo.js.map